import angular from 'angular';
import RatingStar from './ratingStar';

export default angular
  .module('components.ratingStar', [])
  .component('ratingStar', RatingStar).name;
